import styled from 'styled-components';
import { mqLargeMin, mqXLargeMin } from 'styled/tools/media-queries';

export const Container = styled.div`
  margin: 16px 16px 24px;
  display: flex;
  justify-content: center;
`;

export const Body = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  max-width: 620px;

  @media ${mqLargeMin} {
    height: 400px;
    max-width: 1404px;
    flex-direction: row;
  }

  @media ${mqXLargeMin} {
    height: 450px;
  }
`;
